import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

export const accessRequestsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/access-requests',
  validateSearch: (search) =>
    z
      .object({
        page,
        status: z.enum(['pending', 'approved', 'rejected', 'revoked']).optional().catch(undefined),
        channel: text,
      })
      .parse(search),
  beforeLoad: requirePermission('users.view'),
  component: lazyRouteComponent(() => import('./pages/access-requests-page'), 'AccessRequestsPage'),
})

export const adminsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/admins',
  validateSearch: (search) =>
    z
      .object({
        page,
        sort: text,
        search: text,
        role: text,
        active: z.enum(['1', '0']).optional().catch(undefined),
      })
      .parse(search),
  beforeLoad: requirePermission('admins.view'),
  component: lazyRouteComponent(() => import('./pages/admins-page'), 'AdminsPage'),
})

export const adminFormRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/admins/$adminId',
  beforeLoad: requirePermission('admins.manage'),
  component: lazyRouteComponent(() => import('./pages/admin-form-page'), 'AdminFormPage'),
})

export const rolesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/roles',
  beforeLoad: requirePermission('admins.view'),
  component: lazyRouteComponent(() => import('./pages/roles-page'), 'RolesPage'),
})
